/**
 * Created by mac on 1/12/21
 */

const GameLevel = function (locationConfig) {
    cleverapps.EventEmitter.call(this);

    this.locationConfig = locationConfig;
};

GameLevel.prototype = Object.create(cleverapps.EventEmitter.prototype);
GameLevel.prototype.constructor = GameLevel;

GameLevel.prototype.destructor = function () {
    runCleaners(this);
};

GameLevel.prototype.withOwnLevel = function () {
    return Boolean(this.locationConfig);
};

GameLevel.prototype.onChangeExp = function () {
    this.checkLevelUp();

    if (cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
        if (cleverapps.instantTournament.isAvailable()) {
            cleverapps.instantTournament.reportScore();
        } else {
            cleverapps.scoreTracker.report();
        }
    }
};

GameLevel.prototype.load = function () {
    if (this.locationConfig) {
        this.level = this.locationConfig.slot.load("ownLevel") || 0;
    }

    if (this.locationConfig) {
        this.exp = cleverapps.exp;
    } else {
        this.exp = ExpHelper.GetMainInstance();
    }

    this.exp.on("changeExp", this.onChangeExp.bind(this), this);
};

GameLevel.prototype._getLevel = function () {
    return this.locationConfig ? this.level : cleverapps.user.currentPhysicalLevel.level;
};

GameLevel.prototype.getLevel = function () {
    return this._getLevel() + 1;
};

GameLevel.prototype.getNextLevel = function () {
    return this._getLevel() + 2;
};

GameLevel.prototype.nextLevelThreshold = function (level) {
    const threshold = this.getConfig().threshold;

    level = level === undefined ? this._getLevel() : level;

    if (level <= threshold.length - 1) {
        return threshold[level];
    }

    const d = level - (threshold.length - 1);
    const lastStep = threshold[threshold.length - 1] - threshold[threshold.length - 2];
    return threshold[threshold.length - 1] + lastStep * d;
};

GameLevel.prototype.checkLevelUp = function () {
    if (this.exp.getExp() >= this.nextLevelThreshold() && (cleverapps.meta.getSelectedLocation().locationConfig.isMain || this.withOwnLevel())) {
        this.trigger("levelUp");
    }
};

GameLevel.prototype.incLevel = function () {
    if (this.locationConfig) {
        this.level++;

        this.locationConfig.slot.save("ownLevel", this.level);
    } else {
        cleverapps.user.currentPhysicalLevel.level++;
        cleverapps.user.save();
    }
};

GameLevel.prototype.moveToNextLevel = function () {
    this.exp.takeExp(this.nextLevelThreshold(), true);
    this.incLevel();

    this.trigger("changeLevel");
    this.exp.onChange();

    cleverapps.lives.processRegenerateState(true);
    cleverapps.lives.trigger("changeAmount");
    cleverapps.user.trigger("recheckAvailable");
    cleverapps.eventBus.trigger("taskEvent", "LEVEL_UP");

    cleverapps.sideBar.refreshAllIcons();
    cleverapps.restoreProgress.update();

    if (!this.withOwnLevel()) {
        this.logLevelUp();
    }
};

GameLevel.prototype.logLevelUp = function () {
    const level = levels.user.currentPhysicalLevel.level;

    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LEVEL_FINISH);

    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.UNIQUE_FINISH);

    connector.conversions.trackEvent(connector.EVENTS.CONVERSIONS.LEVEL_UP, {
        nickname: "d7a_level", level
    });

    if ([1, 2, 3, 4, 5, 6, 7, 8, 10, 13, 15, 20, 22, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100].includes(level)) {
        connector.conversions.trackEvent(connector.EVENTS.CONVERSIONS.LEVEL_REACH + level, {
            nickname: `d180r_level_${level},day180_reach_${level},d7r_level_${level},day7_reach_${level}`
        });
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.GENERAL.LEVEL_UP, {
        level: levels.user.currentPhysicalLevel.level
    });
};

GameLevel.prototype.getConfig = function () {
    if (this.withOwnLevel()) {
        return GameLevelConfig[cleverapps.meta.selectedLocationId()];
    }

    return GameLevelConfig["main"];
};

GameLevel.prototype.getReward = function () {
    return this.getConfig().calcReward(this._getLevel());
};